import React from 'react'
import { Alert, AlertIcon, AlertTitle, AlertDescription, CloseButton } from '@chakra-ui/react'

export const AlertMssg = ( { mssg, ...props } ) => {
  let track = props.currentTrack
  return (
    <Alert status="error" bg="brand.brightRed"
      py={2}
      {...props}>
      <AlertIcon />
      <AlertTitle
        mr={2}
        fontFamily="heading"
        as="h1">
        ERROR
      </AlertTitle>
      <AlertDescription>{mssg}</AlertDescription>
      <CloseButton
        position="absolute"
        top="10px"
        right="10px"
        fontSize="sm"
        onClick={() => props.clickHandler()}
      />
    </Alert>
  )
}